import { sva } from '@terra/ui-styled-system';

export const alertBanner = sva({
  className: 'alertBanner',
  slots: ['root', 'icon', 'content', 'title', 'description', 'actions'],
  base: {
    root: {
      display: 'flex',
      alignItems: 'center',
      gap: '4',
      p: '2',
      borderRadius: 'lg',
      w: 'full',
    },
    icon: {
      flexShrink: 0,
      boxSize: '5',
      alignSelf: 'flex-start',
      mt: '0.5',
    },
    content: {
      flex: '1 1 0',
      minW: '0',
      display: 'flex',
      flexDirection: 'column',
      gap: '2',
    },
    title: {
      color: 'fg.default',
    },
    description: {
      color: 'fg.muted',
    },
    actions: {
      display: 'flex',
      alignItems: 'center',
      gap: '4',
      flexShrink: 0,
    },
  },
  variants: {
    kind: {
      default: {
        root: {
          bg: 'bg.neutral.subtle',
          borderColor: 'border.neutral.muted',
        },
        icon: { color: 'fg.default' },
      },
      success: {
        root: {
          bg: 'bg.neutral.success',
          borderColor: 'border.neutral.success',
          borderWidth: '1px',
          borderStyle: 'solid',
        },
        icon: { color: 'fg.neutral.success' },
      },
      error: {
        root: {
          bg: 'bg.neutral.error',
          borderColor: 'border.neutral.error',
          borderWidth: '1px',
          borderStyle: 'solid',
        },
        icon: { color: 'fg.neutral.error' },
      },
      info: {
        root: {
          bg: 'bg.neutral.info',
          borderColor: 'border.neutral.info',
          borderWidth: '1px',
          borderStyle: 'solid',
        },
        icon: { color: 'fg.neutral.info' },
      },
      attention: {
        root: {
          bg: 'bg.neutral.warning',
          borderColor: 'border.neutral.warning',
          borderWidth: '1px',
          borderStyle: 'solid',
          alignItems: 'flex-start',
          gap: '3',
          p: '3',
        },
        icon: {
          color: 'fg.neutral.warning',
          alignSelf: 'flex-start',
          mt: '0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          lineHeight: '1',
        },
        description: {
          m: '0',
        },
      },
    },
    type: {
      outline: {
        root: {
          borderWidth: '1px',
          borderStyle: 'solid',
          boxShadow: 'none',
        },
      },
      evaluation: {
        root: {
          boxShadow: 'md',
        },
      },
    },
    descriptionOnly: {
      true: {
        icon: { alignSelf: 'center', mt: '0' },
        description: { color: 'fg.default' },
      },
    },
  },
  compoundVariants: [
    {
      kind: 'attention',
      descriptionOnly: true,
      css: {
        root: {
          alignItems: 'flex-start',
        },
        icon: {
          alignSelf: 'flex-start',
          mt: '0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          lineHeight: '1',
        },
        description: {
          m: '0',
        },
      },
    },
  ],
  defaultVariants: {
    kind: 'default',
    type: 'evaluation',
    descriptionOnly: false,
  },
});

export type AlertBannerVariantProps = NonNullable<
  Parameters<typeof alertBanner>[0]
>;
